export default __webpack_public_path__ + "send_icon.63aef0d4.png";